<div data-target="setEmail" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content" *ngIf="contentReady">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>
      <section
        class="dt-l-article__section"
        [ngClass]="isVerified === VERIFYSTATE.OK ? 'dt-l-article__section--success' : 'dt-l-article__section--failed'">
        <h1 class="dt-l-article__section__title" tabindex="-1" *ngIf="isVerified === VERIFYSTATE.OK">
          {{ 'PAGE_HEADING_SUCCESS' | translate }}
        </h1>

        <h1 class="dt-l-article__section__title" tabindex="-1" *ngIf="isVerified === VERIFYSTATE.ERROR">
          {{ 'PAGE_HEADING_ERROR' | translate }}
        </h1>

        <p class="dt-l-article__section__description" *ngIf="isVerified === VERIFYSTATE.LOADING">
          {{ 'PAGE_SUBHEADING_LOADING' | translate }}
        </p>
        <p class="dt-l-article__section__description" *ngIf="isVerified === VERIFYSTATE.OK">
          {{ 'PAGE_SUBHEADING_OK' | translate }}
        </p>
        <p class="dt-l-article__section__description" *ngIf="isVerified === VERIFYSTATE.ERROR">
          {{ 'PAGE_SUBHEADING_ERROR' | translate }}
        </p>

        <button class="dt-c-button primary block inline-block-md" type="button" (click)="routeToLogin()">
          {{ 'BACK_TO_LOGIN' | translate }}
        </button>
      </section>
    </div>
  </article>
</div>
